import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';
import type { Transaction } from '@/types/api/bankid/v2/transaction';

export const getTransaction = async ({ transactionId }: { transactionId: string }): Promise<Transaction> => {
  return (await api.get(`/bankid/${transactionId}`)).data;
};

export const getTransactionQueryOptions = (transactionId: string) => {
  return queryOptions({
    queryKey: ['transactions', transactionId],
    queryFn: () => getTransaction({ transactionId }),
    enabled: Boolean(transactionId),
  });
};

type UseTransactionOptions = {
  transactionId: string;
  queryConfig?: QueryConfig<typeof getTransactionQueryOptions>;
};

export const useTransaction = ({ transactionId, queryConfig }: UseTransactionOptions) => {
  return useQuery({
    ...getTransactionQueryOptions(transactionId),
    ...queryConfig,
  });
};
